import { type ImageDTO } from '@capsicum/common';

/**
 * util that get the partner logo from the all partner images
 * SHARED BETWEEN MOB AND WEB
 *
 * @param {partnerImages} partnerImages list of images of partner, send by search endpoint edto
 *
 * @returns {string} url of the partner logo
 */
export const getPartnerLogo = (partnerImages: Array<ImageDTO>) =>
	partnerImages?.find(img => img?.imageType?.type === 'partner_logo')?.url || '';
